var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 791.4 1279.6",
    style: {
      enableBackground: "new 0 0 791.4 1279.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000065055403446398536800000000296806190309684615_);fill:#FFF5AD;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 791.4,
    height: 1279.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109016973496223527470000000082799223436073649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000109016973496223527470000000082799223436073649_)",
      fill: "#FFF5AD"
    },
    d: "M265,203.3l-27.2,292.2 h3.6c24.2-33.9,55.6-58.4,94.4-73.5c38.7-15.1,85.9-22.7,141.6-22.7c61.7,0,112.8,11.8,153.4,35.4c40.5,23.6,72.6,54.8,96.2,93.5 c23.6,38.7,40.2,82.6,49.9,131.6c9.7,49,14.5,98.9,14.5,149.7c0,71.4-6.1,136.1-18.2,194.2c-12.1,58.1-33.6,108-64.4,149.7 c-30.9,41.7-72.9,73.2-126.1,94.4c-53.3,21.2-121,31.8-203.3,31.8c-81.1,0-146.7-10.9-196.9-32.7c-50.2-21.8-88.7-50.5-115.3-86.2 c-26.6-35.7-44.5-74.4-53.5-116.2C4.5,1002.8,0,963.8,0,927.5V893h250.5c0,21.8,1.2,44.8,3.6,69c2.4,24.2,8.2,46.9,17.2,68.1 c9.1,21.2,22.1,38.7,39,52.6c16.9,13.9,39.3,20.9,67.2,20.9c54.5,0,93.5-20.9,117.1-62.6S530,936.6,530,853.1 c0-53.2-2.4-97.4-7.3-132.5c-4.8-35.1-13-62.9-24.5-83.5c-11.5-20.6-26.9-35.1-46.3-43.6c-19.4-8.5-43.6-12.7-72.6-12.7 c-37.5,0-66.2,10.6-86.2,31.8c-20,21.2-32.4,49.9-37.2,86.2H21.8L69,0h669.8v203.3H265z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo05);
export default __webpack_public_path__ + "static/media/no-05.6e600962935a29efd3a211dfed8351b7.svg";
export { ForwardRef as ReactComponent };